/*!
 * Dalafisk – category row
 * ------------------------------------------------------------------
 * Links the two halves of the section: hovering or focusing a category tile
 * slides the plate row so that category's plate sits in the middle of the
 * scene, and raises it — so it is obvious the plates are the same categories
 * and are themselves clickable.
 *
 * Pairing is by collection handle, written into data-dalafisk-category on
 * both the tile and the plate by the section.
 *
 * The slide is the design's `visa()`: it writes the offset that centres the
 * plate into a custom property the CSS transitions. offsetLeft is the plate's
 * LAYOUT position and is unaffected by the row's own transform, so the centre
 * is always measured from the same origin no matter how far the row has
 * already moved.
 *
 * Pointer only. On touch there is no hover to read and the tile is a link the
 * visitor is about to follow, so the row is left alone.
 *
 * Purely decorative: if this never runs, both halves still work as links.
 */
(function () {
  'use strict';

  if (window.__dalafiskCategoryRow) return;
  window.__dalafiskCategoryRow = true;

  var ACTIVE = 'data-dalafisk-active';
  var SHIFT = '--dalafisk-plates-shift';

  var canHover = !window.matchMedia || window.matchMedia('(hover: hover)').matches;

  function wire(root) {
    var rows = (root || document).querySelectorAll('.dalafisk-category-row');

    Array.prototype.forEach.call(rows, function (row) {
      if (row.__dalafiskWired) return;
      row.__dalafiskWired = true;

      var track = row.querySelector('.dalafisk-category-row__plates');
      var plates = row.querySelectorAll('.dalafisk-category-row__plate');
      if (!plates.length) return;

      var byCategory = {};
      Array.prototype.forEach.call(plates, function (plate) {
        var key = plate.getAttribute('data-dalafisk-category');
        if (key) byCategory[key] = plate;
      });

      function setActive(key, on) {
        var plate = byCategory[key];
        if (!plate) return;
        if (on) plate.setAttribute(ACTIVE, '');
        else plate.removeAttribute(ACTIVE);
      }

      /* Centre the named plate in the scene. Clamped to the row's own travel so
         the first and last plates cannot be pulled in past the scene's edge and
         leave a gap where the counter should be. */
      function centre(key) {
        var plate = byCategory[key];
        if (!track || !plate) return;

        var middle = plate.offsetLeft + plate.offsetWidth / 2;
        var shift = track.clientWidth / 2 - middle;
        var overflow = track.scrollWidth - track.clientWidth;

        if (overflow <= 0) shift = 0;
        else shift = Math.max(-overflow, Math.min(0, shift));

        track.style.setProperty(SHIFT, Math.round(shift) + 'px');
      }

      var tiles = row.querySelectorAll('.dalafisk-category-row__tile');
      Array.prototype.forEach.call(tiles, function (tile) {
        var key = tile.getAttribute('data-dalafisk-category');
        if (!key || !byCategory[key]) return;

        function show() {
          setActive(key, true);
          centre(key);
        }

        if (canHover) {
          tile.addEventListener('mouseenter', show);
          tile.addEventListener('mouseleave', function () { setActive(key, false); });
        }
        // Keyboard users get the same cue, pointer or not.
        tile.addEventListener('focus', show);
        tile.addEventListener('blur', function () { setActive(key, false); });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { wire(document); });
  } else {
    wire(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    wire(e.target || document);
  });
})();
